/**
 * Created by noOne on 05/09/2017.
 */

import Motive3D from "./Motive3D";

export default class Enemy extends Motive3D {
    constructor(type, speed) {
        super(type, speed);
        /**
         * current velocity
         * @type {PIXI.Point}
         * @private
         */
        this._velocity = new PIXI.Point(0.1);

        /**
         * desired velocity
         * @type {PIXI.Point}
         * @private
         */
        this._targetVelocity = new PIXI.Point();

        /**
         * @type {PIXI.Point}
         * @private
         */
        this._steering = new PIXI.Point();

        /**
         * @type {number}
         * @private
         */
        this._maxVelocity = 0.01;

        /**
         * @type {boolean}
         * @private
         */
        this._dead = false;

        this._randomOffset = null;
        var changeOffset = ()=> {
            this._randomOffset = Math.random() - 0.5;
            delay(changeOffset, 2, this);
        };
        changeOffset();
    }

    steer(target) {
        //todo - clamp steering (currently semi snaps, this would make steering smoother)
        target = target || Common.player;

        if (Common.distance(this.x, this.y, target.x, target.y) < 0.5) {
            this._dead = true;
            this.view.renderable = false;//todo - lazy solution, improve
            this.view.visible = false; //actually this is probably fairly optimal.  however do remove from arrays also.
        }

        this._targetVelocity.x = target.x - this.x;
        this._targetVelocity.y = target.y - this.y;

        this._steering.x = this._targetVelocity.x - this._velocity.x + this._randomOffset;
        this._steering.y = this._targetVelocity.y - this._velocity.y + this._randomOffset;

        this._velocity.x += this._steering.x;
        this._velocity.y += this._steering.y;
    }

    followPath(path) {
        const node = path[path.length - 1];
        TweenMax.to(this, 0.75, {
            x: node.pos.x + 0.5,
            y: node.pos.y + 0.5,
            ease: Power0.easeNone,
            onComplete: ()=> {
                path.pop();
                if (path.length > 0) {
                    this.followPath(path);
                } else {
                    console.log("done path");
                }
            }
        });
    }

    update() {
        if (this._dead) return;

        //--calc velocity--//
        this.steer();

        //--update position--//
        this.x += this._velocity.x / 100;//todo - this should be clamped in steering function
        this.y += this._velocity.y / 100;
    }

    get dx() {
        return this._velocity.x;
    }

    set dx(float) {
        this._velocity.x = float;
    }

    get dy() {
        return this._velocity.y;
    }

    set dy(float) {
        this._velocity.y = float;
    }
}